module.exports = __webpack_public_path__ + "abb3956ba87a600668168cef6a8e79e2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/error-owl.png
// module id = 321
// module chunks = 0